export var Frequency;
(function (Frequency) {
    Frequency["daily"] = "daily";
    Frequency["weekly"] = "weekly";
    Frequency["fortnightly"] = "fortnightly";
    Frequency["monthly"] = "monthly";
    Frequency["yearly"] = "yearly";
})(Frequency || (Frequency = {}));
export var Gender;
(function (Gender) {
    Gender["male"] = "male";
    Gender["female"] = "female";
})(Gender || (Gender = {}));
export var Title;
(function (Title) {
    Title["Dr"] = "Dr";
    Title["Mr"] = "Mr";
    Title["Mrs"] = "Mrs";
    Title["Miss"] = "Miss";
    Title["Ms"] = "Ms";
    Title["Other"] = "Other";
})(Title || (Title = {}));
export var enumToString = function (enumType) {
    var result = [];
    for (var key in enumType) {
        result.push(enumType[key]);
    }
    return result;
};
//# sourceMappingURL=enum.js.map